import 'core-js/modules/es.object.assign.js';
import { useContainer } from '@hub-la/fe-container';
import { HttpClient } from '@hub-la/fe-core-http-client';
import { useMutation, useQueryClient } from 'react-query';
import { QueryKey } from '../../domain/enums/query-keys.js';
import { PostComment } from '../../usecases/post-comment.js';
import { useDiscussion } from '../providers/discussion.js';

const usePostComment = ({
  onSuccess,
  currentUser
} = {}) => {
  const container = useContainer();
  const queryClient = useQueryClient();
  const discussion = useDiscussion();
  const user = currentUser !== null && currentUser !== void 0 ? currentUser : discussion === null || discussion === void 0 ? void 0 : discussion.currentUser;
  return useMutation([QueryKey.postComment], input => {
    var _a;
    return new PostComment(container.get(HttpClient)).execute(Object.assign(Object.assign({}, input), {
      postId: (_a = discussion === null || discussion === void 0 ? void 0 : discussion.metadata) === null || _a === void 0 ? void 0 : _a.postId
    }));
  }, {
    retry: false,
    onSuccess: (data, input) => {
      var _a, _b;
      if (onSuccess) {
        onSuccess();
      }
      queryClient.setQueryData([QueryKey.getComments, (_a = input.postId) !== null && _a !== void 0 ? _a : (_b = discussion === null || discussion === void 0 ? void 0 : discussion.metadata) === null || _b === void 0 ? void 0 : _b.postId, discussion === null || discussion === void 0 ? void 0 : discussion.orderDir], commentsData => {
        var _a, _b;
        if (!commentsData) {
          return {
            pages: [],
            pageParams: []
          };
        }
        if (input.parentCommentId) {
          commentsData.pages = commentsData.pages.map(page => {
            var _a;
            const oldItems = (_a = page.items) !== null && _a !== void 0 ? _a : [];
            const updatedItems = oldItems.map(comment => {
              if (comment.id === input.parentCommentId) {
                return Object.assign(Object.assign({}, comment), {
                  repliesCount: comment.repliesCount + 1,
                  latestReplyAt: new Date().toISOString()
                });
              }
              return comment;
            });
            return Object.assign(Object.assign({}, page), {
              items: updatedItems
            });
          });
          return commentsData;
        }
        if (data) {
          // If it's a new comment, we add it to the first page because counter use the first page
          commentsData.pages[0].total += 1;
          commentsData.pages[0].items.unshift(Object.assign(Object.assign({}, data), {
            likesCount: 0,
            repliesCount: 0,
            user: {
              name: (_a = user === null || user === void 0 ? void 0 : user.name) !== null && _a !== void 0 ? _a : '',
              picture: (_b = user === null || user === void 0 ? void 0 : user.picture) !== null && _b !== void 0 ? _b : null
            },
            hasOwnerReply: false,
            hasUserLike: false,
            wasEdited: false,
            discussionOwner: null
          }));
        }
        return commentsData;
      });
      if (input.parentCommentId) {
        queryClient.invalidateQueries([QueryKey.getCommentReplies, input.parentCommentId]);
      }
    }
  });
};

export { usePostComment };
